<template>
  <div :class="$style.conatiner">
    <template v-if="payoutSums.length > 0">
      <div
        v-for="(value, idx) in progress"
        :key="idx"
        :class="[$style.progress, computedClasses]"
        :style="{
          width: `${value}%`,
          ...getAnimationDelayVariables(),
        }"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PayoutProgressBar',
  props: {
    payoutSums: {
      type: Array,
      default: () => [],
    },
    isFilled: Boolean,
    loading: Boolean,
  },
  computed: {
    computedClasses() {
      return {
        [this.$style.filled]: this.isFilled,
        [this.$style.loading]: this.loading,
      };
    },
    progress() {
      if (this.loading) {
        return [100];
      }

      if (this.$validate.isEmptyArray(this.payoutSums)) {
        return [0];
      }

      return this.payoutSums;
    },
  },
  methods: {
    getAnimationDelayVariables() {
      return {
        '--animation-cycle': `${Math.random() * 0.8}s`,
        '--animation-delay': `${Math.random() * 0.5}s`,
      };
    },
  },
};
</script>

<style lang="sass" module>
  .conatiner
    +size(100%, 5px)
    +flexbox
    border-radius: 10px
    background-color: var(--color-dark-blue)
    overflow: hidden

  .progress
    height: 100%
    min-width: 5px
    position: relative
    background-color: var(--color-green)

    &:not(:last-child)
      &::after
        content: ''
        width: 2px
        position: absolute
        top: 0
        right: 0
        bottom: 0
        background-color: var(--color-dark-blue)

    &.filled
      background-color: var(--color-red)

    &.loading
      background-color: var(--color-white)
      animation: fade calc(var(--animation-cycle) + 1.2s) linear var(--animation-delay) infinite
      opacity: 0.05

  @keyframes fade
    0%
      opacity: 0.05
    50%
      opacity: .2
    100%
      opacity: 0.05
</style>
